import { createReducer, on } from '@ngrx/store';
import { ContractState, initialContractState } from './contract.state';
import { CONTRACT_ACTIONS } from '.';

export const contractReducer = createReducer(
  initialContractState,

  // Contract

  on(
    CONTRACT_ACTIONS.contractsSuccess,
    (state, { contracts }): ContractState => ({ ...state, contracts, loading: false })
  ),
  on(
    CONTRACT_ACTIONS.setCurrentContract,
    (state, { currentContract }): ContractState => ({
      ...state,
      currentContract,
      loading: false,
    })
  ),
  on(
    CONTRACT_ACTIONS.setCurrentContractWithOutSideEffects,
    (state, { currentContract }): ContractState => ({
      ...state,
      currentContract,
      loading: false,
    })
  ),
  on(
    CONTRACT_ACTIONS.setCurrentContractForInvoice,
    (state, { currentContract }): ContractState => ({
      ...state,
      currentContract,
      loading: false,
    })
  ),
  on(
    CONTRACT_ACTIONS.setContractPopUpTitle,
    (state, { popupTitle }): ContractState => ({
      ...state,
      popupTitle,
      loading: false,
    })
  ),
  on(
    CONTRACT_ACTIONS.updateGridAfterAddContractSuccess,
    (state, { addedContractId }): ContractState => ({
      ...state,
      addedContractId,
      loading: false,
    })
  ),
  on(
    CONTRACT_ACTIONS.resetAddedContractSlice,
    (state): ContractState => ({
      ...state,
      addedContractId: initialContractState.addedContractId,
      loading: false,
    })
  ),

  on(
    CONTRACT_ACTIONS.contractsFailure,
    (state, { error }): ContractState => ({ ...state, error, loading: false })
  ),

  // Contract Capture Types
  on(
    CONTRACT_ACTIONS.setContractCaptureTypesSuccess,
    (state, { contractCaptureTypes }): ContractState => ({
      ...state,
      contractCaptureTypes,
      loading: false,
    })
  ),

  // Contract Group Types
  on(
    CONTRACT_ACTIONS.triggerContractGroupTypes,
    (state): ContractState => ({
      ...state,
      loading: true,
    })
  ),
  on(
    CONTRACT_ACTIONS.contractGroupTypesSuccess,
    (state, { contractGroupTypes }): ContractState => ({
      ...state,
      contractGroupTypes,
      loading: false,
    })
  ),
  on(
    CONTRACT_ACTIONS.contractGroupTypesFailure,
    (state, { error }): ContractState => ({ ...state, error, loading: false })
  ),

  // Contract Programs
  on(
    CONTRACT_ACTIONS.triggerContractPrograms,
    (state): ContractState => ({
      ...state,
      loading: true,
    })
  ),
  on(
    CONTRACT_ACTIONS.contractProgramsSuccess,
    (state, { contractPrograms }): ContractState => ({
      ...state,
      contractPrograms,
      loading: false,
    })
  ),
  on(
    CONTRACT_ACTIONS.contractProgramsFailure,
    (state, { error }): ContractState => ({ ...state, error, loading: false })
  ),
  on(
    CONTRACT_ACTIONS.triggerSysFlightCardComponents,
    (state): ContractState => ({
      ...state,
      loading: true,
    })
  ),
  on(
    CONTRACT_ACTIONS.sysFlightCardComponentsFailure,
    (state, { error }): ContractState => ({ ...state, error, loading: false })
  ),
  on(
    CONTRACT_ACTIONS.setAccountManagerDetails,
    (state, { accountManagerName, accountManagerId }): ContractState => ({
      ...state,
      currentContract: {
        ...state.currentContract,
        accountManagerName,
        accountManagerId,
      },
    })
  ),
  on(
    CONTRACT_ACTIONS.setLatestContractStatusDetails,
    (
      state,
      { contractStatusName, contractStatusId, contractTransactionEndDate }
    ): ContractState => ({
      ...state,
      currentContract: {
        ...state.currentContract,
        contractStatusName,
        contractStatusId,
        contractTransactionEndDate,
      },
    })
  ),
  on(
    CONTRACT_ACTIONS.setEstimatedAndAnnouncedValue,
    (state, { estimatedValue, announcedValue }): ContractState => ({
      ...state,
      currentContract: {
        ...state.currentContract,
        estimatedValue,
        announcedValue,
      },
    })
  ),
  on(
    CONTRACT_ACTIONS.setWarrantyInfo,
    (state, { warrantyInfo }): ContractState => ({
      ...state,
      currentContract: {
        ...state.currentContract,
        warrantyExpiryDate: warrantyInfo.apuwarrantyExpiryDate,
        warrantyExpiryHours: warrantyInfo.warrantyExpiryHours,
        leftEngineWarrantyExpiryDate: warrantyInfo.leftEngineWarrantyExpiryDate,
        leftEngineWarrantyExpiryHours: warrantyInfo.leftEngineWarrantyExpiryHours,
        rightEngineWarrantyExpiryDate: warrantyInfo.rightEngineWarrantyExpiryDate,
        rightEngineWarrantyExpiryHours: warrantyInfo.rightEngineWarrantyExpiryHours,
        apuwarrantyExpiryDate: warrantyInfo.apuwarrantyExpiryDate,
        apuwarrantyExpiryHours: warrantyInfo.apuwarrantyExpiryHours,
        cabinWarrantyExpiryDate: warrantyInfo.cabinWarrantyExpiryDate,
        cabinWarrantyExpiryHours: warrantyInfo.cabinWarrantyExpiryHours,
      },
    })
  ),
  on(
    CONTRACT_ACTIONS.setContractFlightCardComponents,
    (state, { contractFlightCardComponents }): ContractState => ({
      ...state,
      currentContractFlightCardComponents: contractFlightCardComponents,
    })
  ),
  on(
    CONTRACT_ACTIONS.clearContractFlightCardComponents,
    (state): ContractState => ({
      ...state,
      currentContractFlightCardComponents: [],
    })
  ),
  on(
    CONTRACT_ACTIONS.setSysFlightCardComponents,
    (state, { sysFlightCardComponents }): ContractState => ({
      ...state,
      sysFlightCardComponents: sysFlightCardComponents,
    })
  ),
  on(
    CONTRACT_ACTIONS.setSysFlightCardComponentTypes,
    (state, { sysFlightCardComponentTypes }): ContractState => ({
      ...state,
      sysFlightCardComponentTypes: sysFlightCardComponentTypes,
    })
  ),
  on(
    CONTRACT_ACTIONS.setRateEscalationSuccess,
    (state, { rateEscalation }): ContractState => ({
      ...state,
      rateEscalationTypes: rateEscalation,
    })
  ),
  on(
    CONTRACT_ACTIONS.setContractBillingEntitySuccess,
    (state, { contractBillingEntities }): ContractState => ({
      ...state,
      contractBillingEntities: contractBillingEntities,
    })
  ),
  on(
    CONTRACT_ACTIONS.setContractEntitySuccess,
    (state, { contractEntities }): ContractState => ({
      ...state,
      contractEntities: contractEntities,
    })
  ),
  on(
    CONTRACT_ACTIONS.setAdminStaffs,
    (state, { adminStaffs }): ContractState => ({
      ...state,
      adminStaffs: adminStaffs,
    })
  ),
  on(
    CONTRACT_ACTIONS.clearAdminStaffs,
    (state): ContractState => ({
      ...state,
      adminStaffs: [],
    })
  ),
  on(
    CONTRACT_ACTIONS.setSysContractStatuses,
    (state, { sysContractStatuses }): ContractState => ({
      ...state,
      sysContractStatuses: sysContractStatuses,
    })
  ),
  on(
    CONTRACT_ACTIONS.setSysContractStatusChangeReasons,
    (state, { sysContractStatusChangeReasons }): ContractState => ({
      ...state,
      sysContractStatusChangeReasons: sysContractStatusChangeReasons,
    })
  ),
  on(
    CONTRACT_ACTIONS.loadContractTransfers,
    (state): ContractState => ({
      ...state,
      loading: true,
    })
  ),
  on(
    CONTRACT_ACTIONS.loadContractTransfersSuccess,
    (state, { contractTransfers }): ContractState => ({
      ...state,
      contractTransfers,
      loading: false,
    })
  ),
  on(
    CONTRACT_ACTIONS.updateContractTransfers,
    (state, { transfers }): ContractState => ({
      ...state,
      contractTransfers: transfers,
    })
  ),
  on(
    CONTRACT_ACTIONS.setSysClientReportTypes,
    (state, { sysClientReportTypes }): ContractState => ({
      ...state,
      sysClientReportTypes: sysClientReportTypes,
    })
  ),
  on(
    CONTRACT_ACTIONS.setProductSuccess,
    (state, { products }): ContractState => ({
      ...state,
      products: products,
    })
  ),
  on(
    CONTRACT_ACTIONS.contractGroupingForAnalyticSuccess,
    (state, { contractGroupingAnalytics }): ContractState => ({
      ...state,
      contractGroupingAnalytics,
      loading: false,
    })
  ),
  on(
    CONTRACT_ACTIONS.triggerContractProductShortNames,
    (state, { currentContract }): ContractState => ({
      ...state,
      currentContract,
      loading: false,
    })
  ),
  on(
    CONTRACT_ACTIONS.setContractProductShortNames,
    (state, { contractProductShortNames }): ContractState => ({
      ...state,
      contractProductShortNames,
    })
  ),
  on(
    CONTRACT_ACTIONS.setContractProductSuccess,
    (state, { contractProducts }): ContractState => ({
      ...state,
      contractProducts,
    })
  ),
  on(
    CONTRACT_ACTIONS.setContractNextFlightCard,
    (state, { nextFlightCards }): ContractState => ({
      ...state,
      nextFlightCards,
    })
  ),
  on(
    CONTRACT_ACTIONS.clearContractProductShortNames,
    (state): ContractState => ({
      ...state,
      contractProductShortNames: '',
    })
  ),
  on(
    CONTRACT_ACTIONS.adminStaffsForRegionalSalesManager,
    (state, { regionalSaleManagerStaffs }): ContractState => ({
      ...state,
      regionalSaleManagerStaffs,
      loading: false,
    })
  )
);
